"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var common = function () {
    var formatDate = function formatDate(date) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "DD/MM/YYYY";

        return (0, _moment2.default)(date).utc().format(format);
    };

    var converToUtcDate = function converToUtcDate(date) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    };

    var subtractDays = function subtractDays(date, numberOfDays) {
        var newDate = (0, _moment2.default)(date).subtract(numberOfDays, "days");
        return new Date(newDate);
    };

    return { formatDate: formatDate, converToUtcDate: converToUtcDate, subtractDays: subtractDays };
}();

exports.default = common;


/** WEBPACK FOOTER **
 ** ./client/app/utils/common.js
 **/